import {
  BROWSER_TIMEZONE_COOKIE,
  FINGERPRINT_EVENT_COOKIE,
  FINGERPRINT_EVENT_MAX_AGE_SECONDS,
} from "@repo/common";

const BROWSER_TIMEZONE_MAX_AGE_SECONDS = 24 * 60 * 60;

function writeCookie(name: string, value: string, maxAgeSeconds: number) {
  const secure = location.protocol === "https:" ? "; secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAgeSeconds}; path=/; samesite=lax${secure}`;
}

/**
 * Keeps the browser's time zone in a cookie, so a risk event recorded on a
 * navigation (an OAuth callback, a magic-link click, the apply entry render)
 * can compare it with the IP's. Rewritten on every page load.
 */
export function rememberBrowserTimezone(): void {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timeZone) {
      writeCookie(
        BROWSER_TIMEZONE_COOKIE,
        timeZone,
        BROWSER_TIMEZONE_MAX_AGE_SECONDS,
      );
    }
  } catch {
    // The event records no browser time zone.
  }
}

/** Lets the next navigation's risk event name this identification. */
export function rememberFingerprintEvent(eventId: string): void {
  writeCookie(
    FINGERPRINT_EVENT_COOKIE,
    eventId,
    FINGERPRINT_EVENT_MAX_AGE_SECONDS,
  );
}
